module.exports = __webpack_public_path__ + "pumpkin.jpg?d31bcd8a7fd8e54ee6a95a655d896be1";